export default function CTASection() {
  return (
    <section className="relative w-full min-h-[480px] md:min-h-[560px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20diverse%20fashion%20accessories%20including%20leather%20goods%20watches%20sunglasses%20and%20small%20bags%20arranged%20in%20an%20elegant%20scattered%20pattern%20on%20a%20warm%20cream%20linen%20surface%2C%20editorial%20fashion%20photography%2C%20soft%20diffused%20overhead%20lighting%20casting%20gentle%20shadows%2C%20warm%20terracotta%20sand%20and%20olive%20green%20accents%2C%20curated%20luxury%20aesthetic%2C%20sophisticated%20magazine%20editorial%20composition&width=1800&height=800&seq=cta-bg-v3-p4q5&orientation=landscape"
          alt="CSSBuy Spreadsheet CTA background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
          <div className="max-w-xl">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
              Comece Agora
            </h2>
            <p className="text-background-50/80 text-base md:text-lg leading-relaxed">
              Acesse a ferramenta principal e descubra como o CSSBuy Spreadsheet pode transformar sua experi&ecirc;ncia de compras internacionais. R&aacute;pido, organizado e econ&ocirc;mico.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-between gap-3 px-8 py-4 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              cssbuy spreadsheet
              <span className="w-8 h-8 rounded-full bg-background-50/20 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-between gap-3 px-8 py-4 rounded-full bg-background-50 text-foreground-900 text-base font-semibold hover:bg-background-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <span className="w-8 h-8 rounded-full bg-foreground-900 flex items-center justify-center">
                <i className="ri-shopping-cart-line text-background-50 text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}